import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { useNotification } from '../../../../../../hooks'
import {
  toggleEmailRead,
  updateEmail,
  useMassMailingAsyncAction,
} from '../../../../../Email'

export function useRequestProfileTabEmailsThreadModalMessageHandlers({
  mailUuid,
  onReloadList,
  onReloadProfile,
}) {
  const { handleAddSuccessNotification } = useNotification()

  const { checkAsyncMassMailingTaskStatus, getAsyncTaskId } =
    useMassMailingAsyncAction(EMPTY_OBJECT)

  async function updateMessage({ id, ...restData }, successTitle) {
    return updateEmail(id, restData, true).then(() => {
      handleAddSuccessNotification(successTitle)
    })
  }

  async function handleMarkAsUnread() {
    return toggleEmailRead({ uuid: mailUuid })
  }

  async function handleFinishReply() {
    onReloadList?.()

    return onReloadProfile()
  }

  async function handleSuccessReply({ data }) {
    const taskId = getAsyncTaskId(data)

    if (taskId) {
      checkAsyncMassMailingTaskStatus(
        { ...data, task: taskId },
        handleFinishReply
      )

      return
    }

    return handleFinishReply()
  }

  return {
    handleMarkAsUnread,
    handleSuccessReply,
    updateMessage,
  }
}
